import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import axios from 'axios';
import { requestWithoutToken } from 'src/config';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  async loginUser(payload: any) {
    return requestWithoutToken(
      "POST",
      "/auth/login",
      payload
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  isUserLoggedIn() {
    if (localStorage.getItem('marieTokenAdmin')) {
      return true;
    }
    else {
      return false;
    }
  }
}
